/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : Home.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */


import React, { useCallback, useEffect, useState } from "react";
import customConsole from "../../config/customConsole";
import { useDispatch, useSelector } from "react-redux";
import {
  dashboardAction,
  HandleApiActions,
  labCar,
  projectConfigAPI,
} from "../../redux/actions";
import {
  Box,
  Grid,
  Typography,
  DialogTitle,
  DialogContent,
  DialogActions,
  Dialog,
} from "@mui/material";

import GraphCard from "../../components/customComponentsV2/dashboard/graph/GraphCard";
import HomologationStatusGraph from "../../components/customComponentsV2/dashboard/graph/HomologationStatusGraph";
import BarGraph from "../../components/customComponentsV2/dashboard/graph/BarGraph";
import RecentActivities from "../../components/customComponentsV2/dashboard/pages/RecentActivities";
import { componentStyle } from "../../config/appTheme";
import CustomFilterV2 from "../../components/customComponentsV2/common/filter/CustomFilterV2";
import CustomSelectV2 from "../../components/customComponentsV2/common/select/CustomSelectV2";
import ProjectVariantSearchbar from "../../components/customComponentsV2/common/projectSearchbar/ProjectvariantSearchbar";
import CustomButtonV2 from "../../components/customComponentsV2/common/button/CustomButtonV2";
import reportTemplateAction from "../../redux/actions/reporting/reportTemplateActions";

const ticketStatusNames = {
  101: "Draft",
  100: "New",
  150: "Confirm Legal Requirements",
  200: "Artifact Confirmation",
  300: "Evidence Submission",
  400: "Evidence Review",
  500: "Testing at TA reviewers",
  600: "Resolved",
  999: "Closed Incomplete",
};
const resolvedTicketsStatus = [600];

const tsChartsStyles = {
  101: "#D0D0CE", // Draft
  100: "#9DD4CF", // New
  200: "#007680", // Artifact Confirmation
  300: "#004F59", // Evidence Submission
  400: "#C4D600", // Evidence Review
  500: "#009A44", // Testing at TA reviewers
  600: "#2C5234", // Resolved
};

function Home() {
  const dispatch = useDispatch();

  const selectedProject = useSelector(
    (state) => state?.projectConfigReducer?.selectedProjectDetails,
  );
  const selectedVariant = useSelector(
    (state) => state.projectConfigReducer.selectedVariantDetails,
  );

  const profileDetails = useSelector((store) => store.profileReducer);

  const roleType = profileDetails?.profile?.role_details?.role_type;


  const techUser = roleType === 1;




  const [ticketsStatusData, setTicketsStatusData] = useState([]);
  const [ticketsStatusList, setTicketsStatusList] = useState([]);

  const [vehicleFunctionList, setVehicleFunctionList] = useState([]);

  const [tsUsersList, setTsUsersList] = useState([]);

  const [hsVfOptionsList, setHsVfOptionsList] = useState([]);
  const [selectedHsVf, setSelectedHsVf] = useState(0);
  const [tsVfOptionsList, setTsVfOptionsList] = useState([]);
  const [selectedTsVf, setSelectedTsVf] = useState(0);
  const [ultUsersOptionsList, setUltUsersOptionsList] = useState([]);
  const [selectedUltUser, setSelectedUltUser] = useState(0);

  const [homologationStatus, setHomologationStatus] = useState([
    ["Status", "Tickets"],
    ["Target", 0],
    ["Completion", 0],
  ]);

  const [ticketsStatus, setTicketsStatus] = useState([
    ["Status", "Count"],
    ["Draft", 0],
    ["New", 0],
    ["AC", 0],
    ["ES", 0],
    ["ER", 0],
    ["WT", 0],
    ["Resolved", 0],
  ]);
  const [userLevelTickets, setUserLevelTickets] = useState([
    ["Status", "Count"],
    ["Draft", 0],
    ["New", 0],
    ["Artifact Confirmation", 0],
    ["Evidence Submission", 0],
    ["Evidence Review", 0],
    ["Testing at TA reviewers", 0],
    ["Resolved", 0],
  ]);

  const [anchorElHsFilter, setAnchorElHsFilter] = useState(null);
  const [anchorElTsFilter, setAnchorElTsFilter] = useState(null);
  const [anchorElUltFilter, setAnchorElUltFilter] = useState(null);

  const [openHsFilter, setOpenHsFilter] = useState(false);
  const [openTsFilter, setOpenTsFilter] = useState(false);
  const [openUltFilter, setOpenUltFilter] = useState(false);

  const [hsFilteredData, setHsFilteredData] = useState(null);
  const [tsFilteredData, setTsFilteredData] = useState(null);
  const [ultFilteredData, setUltFilteredData] = useState(null);

  const selectedProjectId = selectedProject?.project_id;

  const templates = useSelector(
    (state) => state.reportTemplateReducer?.items || [],
  );

  const [generateOpen, setGenerateOpen] = useState(false);
  const [selectedTemplateId, setSelectedTemplateId] = useState("");
  const [loadingGenerate, setLoadingGenerate] = useState(false);
  const [canCompleteProject, setCanCompleteProject] = useState(false);

  const handleHsFilterIconClick = (event) => {
    setAnchorElHsFilter(event.currentTarget);
    setOpenHsFilter(true);
  };
  const handleTsFilterIconClick = (event) => {
    setAnchorElTsFilter(event.currentTarget);
    setOpenTsFilter(true);
  };
  const handleUltFilterIconClick = (event) => {
    setAnchorElUltFilter(event.currentTarget);
    setOpenUltFilter(true);
  };

  const handleHsFilterIconClose = () => {
    setAnchorElHsFilter(null);
    setOpenHsFilter(false);
  };
  const handleTsFilterIconClose = () => {
    setAnchorElTsFilter(null);
    setOpenTsFilter(false);
  };
  const handleUltFilterIconClose = () => {
    setAnchorElUltFilter(null);
    setOpenUltFilter(false);
  };

  const updateHomologationStatus = ({ pending, resolved }) => {
    setHomologationStatus([
      ["Status", "Tickets"],
      ["Target", pending],
      ["Completion", resolved],
    ]);
  };

  const handleGenerate = async () => {
    try {
      setLoadingGenerate(true);

      const resp = await Promise.resolve(
        dispatch(
          HandleApiActions({
            api_name: "/PCM/reports/generate",
            https_method: "POST",
            params: {
              scope_type: "VEHICLE_PROGRAM",
              project_id: selectedProjectId, // ensure this exists
              variant_id: selectedVariant?.variant_id,
              template_id: selectedTemplateId,
            },
            show_toast: true,
          }),
        ),
      );

      const s3Key = resp?.data?.s3_key;
      if (!s3Key) return;

      const signed = await Promise.resolve(
        dispatch(
          HandleApiActions({
            api_name: "/FSM/v1/assets/download/get/presigned-url",
            https_method: "GET",
            params: { key: s3Key },
            show_toast: false,
          }),
        ),
      );

      const url = signed?.data?.url;
      if (url) window.open(url, "_blank");

      setGenerateOpen(false);
      setSelectedTemplateId("");
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingGenerate(false);
    }
  };

  const getTicketsStatus = useCallback(
    async (projectId, variantId) => {
      const apiDetails = dashboardAction.get_tickets_status;
      customConsole({
        ...apiDetails,
        params: {
          ...(projectId && { project_id: projectId }),
        },
      });
      const resp = await Promise.resolve(
        dispatch(
          HandleApiActions({
            ...apiDetails,
            params: {
              ...(projectId && { project_id: projectId }),
              ...(variantId && { variant_id: variantId }),
            },
          }),
        ),
      );
      if (resp.error) {
        setTicketsStatusData([]);
      } else {
        setTicketsStatusData(resp.data);
      }
    },
    [dispatch],
  );

  const updateTicketsStatus = (statusData) => {
    const statusCounts = Object.keys(ticketStatusNames)?.reduce(
      (acc, status) => {
        acc[status] = 0;
        return acc;
      },
      {},
    );

    for (const { ticket_status } of statusData || []) {
      if (Object.hasOwn(statusCounts, ticket_status)) {
        statusCounts[ticket_status] += 1;
      }
    }

    const updatedStatus = [
      ["Status", "Count", { role: "style" }, { role: "annotation" }],
      [
        "Draft",
        statusCounts[101],
        tsChartsStyles[101],
        statusCounts[101],
        "Draft",
      ],
      ["New", statusCounts[100], tsChartsStyles[100], statusCounts[100], "New"],
      [
        "Artifact Confirmation [AC]",
        statusCounts[200],
        tsChartsStyles[200],
        statusCounts[200],
        "AC",
      ],
      [
        "Evidence Submission [ES]",
        statusCounts[300],
        tsChartsStyles[300],
        statusCounts[300],
        "ES",
      ],
      [
        "Evidence Review [ER]",
        statusCounts[400],
        tsChartsStyles[400],
        statusCounts[400],
        "ER",
      ],
      [
        "Witness Testing [WT]",
        statusCounts[500],
        tsChartsStyles[500],
        statusCounts[500],
        "WT",
      ],
      [
        "Resolved",
        statusCounts[600],
        tsChartsStyles[600],
        statusCounts[600],
        "Resolved",
      ],
    ];

    setTicketsStatus(updatedStatus);
  };

  const updateUserTicketsStatus = (statusData) => {
    const statusCounts = Object.keys(ticketStatusNames).reduce(
      (acc, status) => {
        acc[status] = 0;
        return acc;
      },
      {},
    );

    for (const { ticket_status } of statusData || []) {
      if (Object.hasOwn(statusCounts, ticket_status)) {
        statusCounts[ticket_status] += 1;
      }
    }

    const updatedStatus = [
      ["Status", "Count", { role: "style" }, { role: "annotation" }],
      [
        "Draft",
        statusCounts[101],
        tsChartsStyles[101],
        statusCounts[101],
        "Draft",
      ],
      ["New", statusCounts[100], tsChartsStyles[100], statusCounts[100], "New"],
      [
        "Artifact Confirmation [AC]",
        statusCounts[200],
        tsChartsStyles[200],
        statusCounts[200],
        "AC",
      ],
      [
        "Evidence Submission [ES]",
        statusCounts[300],
        tsChartsStyles[300],
        statusCounts[300],
        "ES",
      ],
      [
        "Evidence Review [ER]",
        statusCounts[400],
        tsChartsStyles[400],
        statusCounts[400],
        "ER",
      ],
      [
        "Witness Testing [WT]",
        statusCounts[500],
        tsChartsStyles[500],
        statusCounts[500],
        "WT",
      ],
      [
        "Resolved",
        statusCounts[600],
        tsChartsStyles[600],
        statusCounts[600],
        "Resolved",
      ],
    ];

    setUserLevelTickets(updatedStatus);
  };

  useEffect(() => {
    dispatch(HandleApiActions({ ...labCar.get_project_details }));
  }, [dispatch]);

  useEffect(() => {
    if (!generateOpen) return;

    dispatch(
      HandleApiActions({
        ...reportTemplateAction.get_templates,
      }),
    );
  }, [generateOpen, dispatch]);

  useEffect(() => {
    setTicketsStatusData([]);
    setTicketsStatusList([]);
    setVehicleFunctionList([]);
    setTsUsersList([]);
    setHsVfOptionsList([]);
    setSelectedHsVf(0);
    setTsVfOptionsList([]);
    setSelectedTsVf(0);
    setHsFilteredData(0);
    setTsFilteredData(0);
    setUltFilteredData(0);
    setUltUsersOptionsList([]);
    setSelectedUltUser(0);
  }, [selectedProject]);

  useEffect(() => {
    getTicketsStatus(
      Number.isNaN(Number(selectedProject?.project_id))
        ? undefined
        : Number(selectedProject?.project_id),
      Number.isNaN(Number(selectedVariant?.variant_id))
        ? undefined
        : Number(selectedVariant?.variant_id),
    );
  }, [selectedProject, selectedVariant, getTicketsStatus]);

  useEffect(() => {
    const checkCanComplete = async () => {
      if (!selectedProjectId) {
        setCanCompleteProject(false);
        return;
      }

      try {
        const resp = await Promise.resolve(
          dispatch(
            HandleApiActions({
              ...projectConfigAPI.check_project_can_complete,
              params: { project_id: selectedProjectId },
              show_toast: false,
            }),
          ),
        );
        setCanCompleteProject(Boolean(resp?.data?.can_project_complete));
      } catch (err) {
        console.error(err);
        setCanCompleteProject(false);
      }
    };

    void checkCanComplete();
  }, [selectedProjectId, dispatch]);

  useEffect(() => {
    let filteredTicketStatusList = ticketsStatusData?.map((ts) => {
      return {
        ticket_id: ts?.ticket_id,
        ticket_status: ts?.ticket_status,
        ticket_status_name: ticketStatusNames[ts?.ticket_status],
        vf_ids: ts?.vf_ids?.map(String),
        oem_user_ids: ts?.oem_user_ids?.map(String),
        tech_service_user_ids: ts?.tech_service_user_ids?.map(String),
      };
    });
    setTicketsStatusList(filteredTicketStatusList);

    const uniqueVehicleFunctions = ticketsStatusData?.reduce((acc, ticket) => {
      for (const vf of ticket?.vehicle_functions || []) {
        if (!acc?.some((item) => item?.id === vf?.id)) {
          acc.push(vf);
        }
      }
      return acc;
    }, []);

    setVehicleFunctionList(uniqueVehicleFunctions);

    const isUserExists = (accumulator, user) => {
      return accumulator?.some(
        (existingUser) => existingUser?.user_id === user?.user_id,
      );
    };

    const addUniqueUsers = (accumulator, users = []) => {
      for (const user of users) {
        if (!isUserExists(accumulator, user)) {
          accumulator.push(user);
        }
      }
      return accumulator;
    };

    const uniqueUsers = ticketsStatusData?.reduce((accumulator, current) => {
      const users = [
        ...(current?.tech_user_details || []),
        ...(current?.oem_user_details || []),
      ];

      return addUniqueUsers(accumulator, users);
    }, []);
    setTsUsersList(uniqueUsers);
  }, [ticketsStatusData]);

  useEffect(() => {
    const totalTicketsCount = ticketsStatusList?.length || 0;

    let resolvedTicketsCount =
      ticketsStatusList?.filter((ts) =>
        resolvedTicketsStatus?.includes(Number(ts.ticket_status)),
      ).length || 0;

    updateHomologationStatus({
      pending: totalTicketsCount - resolvedTicketsCount,
      resolved: resolvedTicketsCount,
      total: totalTicketsCount,
    });

    updateTicketsStatus(ticketsStatusList);

    updateUserTicketsStatus(ticketsStatusList);
  }, [ticketsStatusList]);

  useEffect(() => {
    let filteredVfOptionsList = vehicleFunctionList?.map((vf) => {
      return {
        value: vf.id,
        label: vf.name,
      };
    });
    filteredVfOptionsList = [
      { value: 0, label: "All" },
      ...filteredVfOptionsList,
    ];

    setHsVfOptionsList(filteredVfOptionsList);
    setTsVfOptionsList(filteredVfOptionsList);
  }, [vehicleFunctionList]);

  useEffect(() => {
    let filteredUsersList = tsUsersList?.map((us) => {
      return {
        value: us?.user_id,
        label: `${us?.name} - ${us?.email}`,
      };
    });
    filteredUsersList = [{ value: 0, label: "All" }, ...filteredUsersList];
    setUltUsersOptionsList(filteredUsersList);
  }, [tsUsersList]);

  useEffect(() => {
    let filteredTicketsStatusList = selectedHsVf
      ? ticketsStatusList?.filter((hs) =>
        hs?.vf_ids?.includes(String(selectedHsVf)),
      )
      : ticketsStatusList;

    const totalTicketsCount = filteredTicketsStatusList?.length || 0;

    let resolvedTicketsCount =
      filteredTicketsStatusList?.filter((ts) =>
        resolvedTicketsStatus?.includes(Number(ts.ticket_status)),
      ).length || 0;

    updateHomologationStatus({
      pending: totalTicketsCount - resolvedTicketsCount,
      resolved: resolvedTicketsCount,
      total: totalTicketsCount,
    });
  }, [selectedHsVf, ticketsStatusList]);

  useEffect(() => {
    let filteredTicketsStatusList = selectedTsVf
      ? ticketsStatusList?.filter((ts) =>
        ts?.vf_ids?.includes(String(selectedTsVf)),
      )
      : ticketsStatusList;

    updateTicketsStatus(filteredTicketsStatusList);
  }, [selectedTsVf, ticketsStatusList]);

  useEffect(() => {
    let filteredTicketsStatusList = selectedUltUser
      ? ticketsStatusList?.filter(
        (ult) =>
          ult?.oem_user_ids?.includes(String(selectedUltUser)) ||
          ult?.tech_service_user_ids?.includes(String(selectedUltUser)),
      )
      : ticketsStatusList;

    updateUserTicketsStatus(filteredTicketsStatusList);
  }, [selectedUltUser, ticketsStatusList]);

  useEffect(() => {
    customConsole({ ticketsStatusData });
    customConsole({ ticketsStatusList });
    customConsole({ vehicleFunctionList });
    customConsole({ tsUsersList });
    customConsole({ selectedHsVf });
  }, [
    ticketsStatusData,
    ticketsStatusList,
    vehicleFunctionList,
    tsUsersList,
    selectedHsVf,
  ]);









  const handleTSFilterButton = (action) => {
    switch (action) {
      case "cancel":
        handleTsFilterIconClose();
        break;
      case "apply":
        setSelectedTsVf(tsFilteredData);
        handleTsFilterIconClose();
        break;
      default:
        console.warn(`Unhandled action: ${action}`);
    }
  };

  const handleHsFilterButton = (action) => {
    switch (action) {
      case "cancel":
        handleHsFilterIconClose();
        break;
      case "apply":
        setSelectedHsVf(hsFilteredData);
        handleHsFilterIconClose();
        break;
      default:
        console.warn(`Unhandled action: ${action}`);
    }
  };

  const handleUltFilterButton = (action) => {
    switch (action) {
      case "cancel":
        handleUltFilterIconClose();
        break;
      case "apply":
        setSelectedUltUser(ultFilteredData);
        handleUltFilterIconClose();
        break;
      default:
        console.warn(`Unhandled action: ${action}`);
    }
  };

  return (
    <Box
      sx={{
        px: 2,
        pt: 1,
        pb: 12,
      }}
    >
      <Box sx={{ width: "100%", display: "flex", mb: 1, ml: 1 }}>
        <Typography sx={{ ...componentStyle?.font?.tabLevelHeader }}>
          Dashboard
        </Typography>
      </Box>
      {!techUser && (
        <Box sx={styles.topContainer}>
          <ProjectVariantSearchbar />
          <Box></Box>
          <Box sx={{ marginLeft: "auto" }}>
            <CustomButtonV2
              btnName="Generate Report"
              handleOnClick={() => setGenerateOpen(true)}
              disabled={!canCompleteProject}
            />
          </Box>
        </Box>
      )}

      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <GraphCard
            heading={
              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                }}
              >

                <CustomFilterV2
                  anchorEl={anchorElHsFilter}
                  open={openHsFilter}
                  iconicFilter={true}
                  border={false}
                  widthPerColumn={"350px"}
                  handleClick={handleHsFilterIconClick}
                  handleFilterButton={handleHsFilterButton}
                  handleClose={handleHsFilterIconClose}
                  actionButtonStyle={{
                    width: "100%",
                    justifyContent: "space-between",
                  }}
                  sections={[
                    {
                      heading: "Homologation Status",
                      content: (
                        <Box
                          sx={{
                            width: "100%",
                            p: 2,
                            justifyContent: "center",
                          }}
                        >
                          <CustomSelectV2
                            optionsList={hsVfOptionsList}
                            selectedValue={hsFilteredData}
                            handleOnChange={(e) => {
                              console.log(
                                "hs filter value",
                                e.target.value,
                                hsVfOptionsList,
                              );
                              setHsFilteredData(e.target.value);
                            }}
                            label={"Select Vehicle Function."}
                          />
                        </Box>
                      ),
                    },
                  ]}
                />
                <Typography sx={{ ...componentStyle.font.cardHeadder, mt: 1 }}>
                  Homologation Status
                </Typography>
              </Box>
            }
          >
            <HomologationStatusGraph data={homologationStatus} />
          </GraphCard>


        </Grid>

        <Grid item xs={12} md={4}>
          <GraphCard
            heading={
              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                }}
              >
                <CustomFilterV2
                  anchorEl={anchorElTsFilter}
                  iconicFilter={true}
                  border={false}
                  widthPerColumn={"350px"}
                  handleClose={handleTsFilterIconClose}
                  open={openTsFilter}
                  handleClick={handleTsFilterIconClick}
                  handleFilterButton={handleTSFilterButton}
                  actionButtonStyle={{
                    width: "100%",
                    justifyContent: "space-between",
                  }}
                  sections={[
                    {
                      heading: "Ticket Status",
                      content: (
                        <Box
                          sx={{
                            width: "100%",
                            p: 2,
                            justifyContent: "center",
                          }}
                        >
                          <CustomSelectV2
                            optionsList={tsVfOptionsList}
                            selectedValue={tsFilteredData}
                            handleOnChange={(e) =>
                              setTsFilteredData(e.target.value)
                            }
                            label={"Select Vehicle Function"}
                          />
                        </Box>
                      ),
                    },
                  ]}
                />
                <Typography sx={{ ...componentStyle.font.cardHeadder, mt: 1 }}>
                  Tickets Status
                </Typography>
              </Box>
            }
          >
            <BarGraph data={ticketsStatus} />
          </GraphCard>

        </Grid>

        <Grid item xs={12} md={4}>
          <GraphCard
            heading={
              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                }}
              >


                <CustomFilterV2
                  anchorEl={anchorElUltFilter}
                  open={openUltFilter}
                  iconicFilter={true}
                  border={false}
                  widthPerColumn={"350px"}
                  handleClick={handleUltFilterIconClick}
                  handleClose={handleUltFilterIconClose}
                  handleFilterButton={handleUltFilterButton}
                  actionButtonStyle={{
                    width: "100%",
                    justifyContent: "space-between",
                  }}
                  sections={[
                    {
                      heading: "User Level Tickets",
                      content: (
                        <Box
                          sx={{
                            width: "100%",
                            p: 2,
                            justifyContent: "center",
                          }}
                        >
                          <CustomSelectV2
                            optionsList={ultUsersOptionsList}
                            selectedValue={ultFilteredData}
                            handleOnChange={(e) =>
                              setUltFilteredData(e.target.value)
                            }
                            label={"Select Users"}
                          />
                        </Box>
                      ),
                    },
                  ]}
                />
                <Typography sx={{ ...componentStyle.font.cardHeadder, mt: 1 }}>
                  User Level Tickets
                </Typography>
              </Box>
            }
          >
            <BarGraph data={userLevelTickets} />
          </GraphCard>

        </Grid>
      </Grid>

      <Box
        sx={{
          mt: 2,
        }}
      >
        <RecentActivities
          recentEEComponent={"Recent EE Component"}
          recentSoftwareModule={"Recent Software Module"}
          recentVehicle={"Recent Vehicle"}
        />
      </Box>

      <Dialog
        open={generateOpen}
        onClose={() => setGenerateOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Select Template</DialogTitle>

        <DialogContent>
          <Box sx={{ mt: 2 }}>
            <CustomSelectV2
              label={"Template"}
              optionsList={templates.map((template) => ({
                label: template.name,
                value: template.id,
              }))}
              selectedValue={selectedTemplateId}
              handleOnChange={(e) => setSelectedTemplateId(e.target.value)}
              dark={false}
              showLabel={true}
            />
          </Box>
        </DialogContent>

        <DialogActions>
          <CustomButtonV2
            type="cancel"
            size="small"
            btnName={"Close"}
            handleOnClick={() => setGenerateOpen(false)}
          />

          <CustomButtonV2
            type="submit"
            size="small"
            btnName={"Download Report"}
            disabled={!selectedTemplateId || loadingGenerate}
            handleOnClick={handleGenerate}
          >
            {loadingGenerate ? "Generating..." : "Generate"}
          </CustomButtonV2>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default Home;




const styles = {
  chartsContainer: {
    width: "100%",
    borderRadius: "10px",
    boxShadow: 6,
    px: 2.5,
    pt: 1,
  },
  topContainer: {
    textAlign: "start",
    display: "flex",
    mb: 3,
    ml: 1,
    gap: 4,
  },
  searchSelectTextField: {
    width: "215px",
    backgroundColor: "white",
  },
  stfNContainer: {
    display: "flex",
    justifyContent: "flex-end",
  },
  selectTxtStyle: {
    width: "190px",
  },
  box: {
    height: "350px",
  },
  paper: {
    boxShadow: 3,
    height: "350px",
    scrollbarColor: "#888 #f1f1f1",
  },
  filter: {
    position: "relative",
    top: "4px",
    right: "8px",
  },
  mainBox: {
    pt: 0,
    boxShadow: 3,
    border: "1px solid #e0e0e0",
    borderRadius: "10px",
    height: "100vh",
    pr: 2,
    pl: 2,
  },
  drawerContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    maxWidth: "400px",
    maxHeight: "500px",
    padding: 2,
    position: "relative",
  },
  closeButton: {
    color: "red",
    position: "absolute",
    top: "4px",
    right: "8px",
  },
  divider: {
    border: "1px solid lightgrey",
    margin: "8px 0",
    marginY: 1,
  },
  paperDrawer: {
    marginBottom: 2,
    padding: 2,
    boxShadow: 10,
    border: "1px solid #e0e0e0",
    borderRadius: "10px",
  },
  drawerWrap: {
    marginTop: 2,
  },

  dataTypographyKey: {
    fontWeight: "bold",
    fontSize: "14px",
    textAlign: "left",
    minWidth: "110px",
  },
  dataTypographyValue: {
    marginLeft: 1,
    fontSize: "14px",
    textAlign: "left",
  },
  dataBox: {
    display: "flex",
    flexDirection: "row",

    alignItems: "center",
    flexWrap: "wrap",
    gap: 1,
  },
  cardContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    maxWidth: "100%",
  },
  card: {
    boxShadow: 3,
    width: "100%",
    height: "auto",
    marginBottom: 1,
    padding: 2,
  },
  cardContent: {
    display: "flex",
    height: "40px",
    alignItems: "center",
    justifyContent: "space-between",
  },
  dataTypography: {
    fontWeight: "bold",
    fontSize: "13px",
    textAlign: "left",
    minWidth: "120px",
  },
  dataTypographyCardKey: {
    fontWeight: "bold",
    fontSize: "15px",
    textAlign: "left",
    minWidth: "50px",
  },
  dataTypographyCardValue: {
    fontSize: "15px",
    textAlign: "left",
    minWidth: "50px",
  },
  btnsContainer: {
    display: "flex",
    justifyContent: "flex-end",
    mb: 1,
    gap: 1,
  },
  cardDrawer: { margin: 1, padding: 2, boxShadow: 3 },
  paginationPaper: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "5px",
  },
  searchContainer: {
    textAlign: "start",
    mt: { xs: 2, md: 0 },
  },
};
